import {
  AfterViewChecked,
  Component,
  ElementRef,
  Input,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';

@Component({
  selector: 'idp-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LoaderComponent implements AfterViewChecked {
  @Input() focus = false;
  @Input() tabIndex = false;
  @Input() spinnerLabel = '';
  @Input() spinnerIconDesktop = '';
  @Input() spinnerIconMobile = '';
  @Input() show = false;
  @Input() spinnerLabelHidden = false;

  @ViewChild('spinnerLoad') spinnerLoad!: ElementRef;

  ngAfterViewChecked() {
    this.setFocusOnLoader();
  }

  /**
   * Function will set focus on loader and add tabIndex to 0
   */
  setFocusOnLoader() {
    if (this.spinnerLabel && this.spinnerLoad?.nativeElement) {
      this.loadSpinner();
    }
  }

  loadSpinner() {
    if (this.tabIndex) {
      this.spinnerLoad.nativeElement.setAttribute('tabindex', '0');
    }
    if (this.focus) {
      this.spinnerLoad.nativeElement.focus();
    }
  }

  tabListener(event: Event) {
    const keyboardEvent = event as KeyboardEvent;
    if (keyboardEvent) {
      if (keyboardEvent.key === 'Tab' || this.tabWithShiftKey(keyboardEvent)) {
        keyboardEvent.preventDefault();
      }
    }
  }

  tabWithShiftKey(event: Event) {
    const keyboardEvent = event as KeyboardEvent;
    return keyboardEvent.key === 'Tab' && keyboardEvent.shiftKey;
  }
}
